import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
  placeOrderApi, getMyOrdersApi, getOrderByIdApi,
  cancelOrderApi, getMyOrderStatsApi,
} from '../api/order.api';

export const ORDER_KEYS = {
  all:    ['orders'],
  list:   (p) => ['orders', 'list', p],
  detail: (id) => ['orders', id],
  stats:  ['orders', 'stats'],
};

export const useMyOrders = (params) =>
  useQuery({
    queryKey: ORDER_KEYS.list(params),
    queryFn: () => getMyOrdersApi(params).then((r) => r.data.data),
  });

export const useOrder = (id) =>
  useQuery({
    queryKey: ORDER_KEYS.detail(id),
    queryFn: () => getOrderByIdApi(id).then((r) => r.data.data),
    enabled: !!id,
  });

export const useMyOrderStats = () =>
  useQuery({
    queryKey: ORDER_KEYS.stats,
    queryFn: () => getMyOrderStatsApi().then((r) => r.data.data),
    staleTime: 2 * 60 * 1000,
  });

export const usePlaceOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: placeOrderApi,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ORDER_KEYS.all });
      toast.success('Order placed successfully');
    },
    onError: (err) => toast.error(err?.response?.data?.message || 'Failed to place order'),
  });
};

export const useCancelOrder = (id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (reason) => cancelOrderApi(id, reason),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ORDER_KEYS.all });
      qc.invalidateQueries({ queryKey: ORDER_KEYS.detail(id) });
      toast.success('Order cancelled');
    },
    onError: (err) => toast.error(err?.response?.data?.message || 'Cannot cancel order'),
  });
};
